const ZaiRefundIgnoreFilterKeys = ['OrderBy', 'SortBy', 'PageNumber', 'PageSize'];

export default ZaiRefundIgnoreFilterKeys;
